import { render, staticRenderFns } from "./RestrictedMessage.vue?vue&type=template&id=beae33fc&scoped=true&"
import script from "./RestrictedMessage.vue?vue&type=script&lang=js&"
export * from "./RestrictedMessage.vue?vue&type=script&lang=js&"
import style0 from "./RestrictedMessage.vue?vue&type=style&index=0&id=beae33fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "beae33fc",
  null
  
)

export default component.exports